import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getWorkspaceUsers } from '../services/workspaceSettingsService';
import type {
  GetWorkspaceUsersParams,
  WorkspaceUsersState,
} from '../types/workspace.types';

const initialState: WorkspaceUsersState = {
  users: [],
  pagination: null,
  emailSearch: '',
  currentPage: 1,
  status: 'idle',
  error: null,
};

export const fetchWorkspaceUsers = createAsyncThunk(
  'settings/workspaceUsers/fetch',
  async (params: GetWorkspaceUsersParams) => {
    return await getWorkspaceUsers(params);
  }
);

const workspaceUsersSlice = createSlice({
  name: 'settingsWorkspaceUsers',
  initialState,
  reducers: {
    setEmailSearch(state, action: PayloadAction<string>) {
      state.emailSearch = action.payload;
      state.currentPage = 1;
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload;
    },
    resetWorkspaceUsers(state) {
      state.users = [];
      state.pagination = null;
      state.emailSearch = '';
      state.currentPage = 1;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkspaceUsers.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchWorkspaceUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.users = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchWorkspaceUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to load workspace users';
      });
  },
});

export const { setEmailSearch, setCurrentPage, resetWorkspaceUsers } =
  workspaceUsersSlice.actions;

export const workspaceUsersReducer = workspaceUsersSlice.reducer;
